module.exports = __webpack_public_path__ + "img/Avatar-20.0cb01388.gif";